<template>
	<v-col>
		<div class="d-flex justify-space-between">
			<div class="font-size-14 font-weight-bold cl-agen-dark">Bonus Summary</div>
		</div>
		<div class="mt-2">
			<template v-if="loading">
				<div class="d-flex flex-wrap">
					
					<v-col cols="12" sm="6" md="3" class="pl-0">
						<v-card class="elevation-0 rounded-xl">
							<vcl :width='300' :height='380'>
								<rect x="15" y="20" rx="20" ry="20" width="40" height="40" />
								<rect x="75" y="20" rx="2" ry="2" width="90" height="18" />
								<rect x="75" y="46" rx="2" ry="2" width="130" height="14" />
								<rect x="15" y="85" rx="2" ry="2" width="80" height="14" />
								<rect x="15" y="108" rx="2" ry="2" width="120" height="18" />
								<rect x="15" y="145" rx="2" ry="2" width="80" height="14" />
								<rect x="15" y="168" rx="2" ry="2" width="120" height="18" />
								<rect x="15" y="205" rx="2" ry="2" width="80" height="14" />
								<rect x="15" y="228" rx="2" ry="2" width="120" height="18" />
								<rect x="15" y="265" rx="2" ry="2" width="80" height="14" />
								<rect x="15" y="288" rx="2" ry="2" width="120" height="18" />
								<rect x="15" y="325" rx="2" ry="2" width="80" height="14" />
								<rect x="15" y="348" rx="2" ry="2" width="120" height="18" />
							</vcl>
						</v-card>
					</v-col>
					<v-col cols="12" sm="6" md="9" class="pr-0">
						<v-row>
							<v-col cols="12" sm="12" md="4" xl="4" class="pb-0" v-for="x in 3" :key="x">
								<v-card class="elevation-0 rounded-xl">
									<vcl :width='300' :height='90'>
										<rect x="30" y="30" rx="20" ry="20" width="40" height="40" />
										<rect x="90" y="30" rx="2" ry="2" width="110" height="20" />
										<rect x="90" y="60" rx="2" ry="2" width="150" height="20" />
									</vcl>
								</v-card>
							</v-col>
							<v-col cols="12" sm="12" md="4" xl="4" class="pb-0" v-for="j in 3" :key="j">
								<v-card class="elevation-0 rounded-xl">
									<vcl :width='300' :height='90'>
										<rect x="30" y="30" rx="20" ry="20" width="40" height="40" />
										<rect x="90" y="30" rx="2" ry="2" width="110" height="20" />
										<rect x="90" y="60" rx="2" ry="2" width="150" height="20" />
									</vcl>
								</v-card>
							</v-col>
							<v-col cols="12" sm="12">
								<v-card class="elevation-0 rounded-xl mt-3" v-for="i in 2" :key="i">
									<vcl :height='30'>
										<rect x="8" y="12" rx="2" ry="2" width="55" height="10" />
										<rect x="105" y="8" rx="2" ry="2" width="45" height="8" />
										<rect x="105" y="20" rx="2" ry="2" width="65" height="8" />
										<rect x="205" y="8" rx="2" ry="2" width="45" height="8" />
										<rect x="205" y="20" rx="2" ry="2" width="65" height="8" />
										<rect x="305" y="8" rx="2" ry="2" width="45" height="8" />
										<rect x="305" y="20" rx="2" ry="2" width="65" height="8" />
									</vcl>
								</v-card>
							</v-col>
						</v-row>
					</v-col>
				</div>
			</template>

			<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
				<template v-if="!loading">
					<div class="d-flex flex-wrap">
						<v-col cols="12" sm="6" md="3" class="pl-0 pr-0 pr-sm-3 flex-stretch justify-center">
							<v-layout column wrap>
								<v-flex style="flex:1" xs12>
									<v-card class="px-4 py-4 elevation-0 rounded-xl hover-shadow fill-height">
										<div>
											<div class="font-size-10 cl-grey">Member Name</div>
											<div class="d-flex align-center mt-1">
												<v-icon normal class="pr-2 grey--text lighten-3">mdi-account-circle-outline</v-icon>
												<div>
													<div class="font-size-10 cl-grey font-weight-bold">{{ myProfile.member_name }}</div>
													<div class="font-size-10 cl-primary font-weight-bold">{{ myProfile.member_ref_network_code ? myProfile.member_ref_network_code : '-' }}</div>
												</div>
											</div>
										</div>
										<div class="pt-3">
											<div class="font-size-10 cl-grey">Join Date</div>
											<div class="d-flex align-center mt-1">
												<v-icon normal class="pr-2 grey--text lighten-3">mdi-calendar-range</v-icon>
												<div class="font-size-10 cl-grey font-weight-bold">{{ myProfile.member_join_datetime | toDate }}</div>
											</div>
										</div>
										<div class="pt-3" v-if="false">
											<div class="font-size-10 cl-grey">Sponsor</div>
											<div class="d-flex align-center mt-1">
												<v-icon normal class="pr-2 grey--text lighten-3">mdi-account-multiple-outline</v-icon>
												<div class="font-size-10 cl-primary font-weight-500">{{ myProfile.member_sponsor_network_code ? myProfile.member_sponsor_network_code : '-' }}</div>
											</div>
										</div>
										<div class="pt-3">
											<div class="font-size-10 cl-grey">Bank Name</div>
											<div class="d-flex align-center mt-1">
												<v-icon normal class="pr-2 grey--text lighten-3">mdi-bank-outline</v-icon>
												<div class="font-size-10 cl-grey font-weight-bold">{{ myProfile.member_bank_name ? myProfile.member_bank_name : '-' }}</div>
											</div>
										</div>
										<div class="pt-3">
											<div class="font-size-10 cl-grey">Bank Account Name</div>
											<div class="d-flex align-center mt-1">
												<v-icon normal class="pr-2 grey--text lighten-3">mdi-clipboard-account-outline</v-icon>
												<div class="font-size-10 cl-grey font-weight-bold">{{ myProfile.member_bank_account_name ? myProfile.member_bank_account_name : '-' }}</div>
											</div>
										</div>
										<div class="pt-3">
											<div class="font-size-10 cl-grey">Bank Account Number</div>
											<div class="d-flex align-center mt-1">
												<v-icon normal class="pr-2 grey--text lighten-3">mdi-credit-card-outline</v-icon>
												<div class="font-size-10 cl-grey font-weight-bold">{{ myProfile.member_bank_account_no ? myProfile.member_bank_account_no : '-' }}</div>
											</div>
										</div>
									</v-card>
								</v-flex>
							</v-layout>
						</v-col>
						<v-col cols="12" sm="6" md="9" class="pr-0 pl-0 pl-sm-3">
							<div class="font-size-12 cl-dark-green font-weight-bold">Bonus Potency</div>
							<v-row justify="start" class="mt-1 mb-3 ml-0" v-if="summaryKomisi.potency">
								<template>
									<v-col cols="12" sm="12" md="6" xl="6" class="pl-0" v-for="(potency, idk) in summaryKomisi.potency" :key="idk">
										<v-card class="pa-4 elevation-0 rounded-xl hover-shadow teal lighten-4">
											<v-row>
												<v-col cols="12">
													<div class="font-size-10 cl-dark-green font-weight-500">{{ potency.label }}</div>
													<div v-if="userData.member_id == '1'" class="font-size-13 cl-dark-green font-weight-500">{{ 0 | toCurrencyFormat }}</div>
													<div v-else class="font-size-13 cl-dark-green font-weight-500">{{ potency.value | toCurrencyFormat }}</div>
												</v-col>
											</v-row>
										</v-card>
									</v-col>
								</template>
							</v-row>
							
							<div class="font-size-12 cl-dark-green font-weight-bold">Bonus Summary</div>
							<v-row justify="center" class="mt-1 mb-2 ml-0">
								<v-col cols="12" sm="12" md="4" xl="4" class="pl-0">
									<v-card class="px-2 py-4 elevation-0 rounded-xl hover-shadow cyan darken-1">
										<v-row>
											<v-col cols="2" sm="3" md="3" class="pr-0 my-auto text-right align-center">
												<img class="img-fluid filter-white" src="/assets/icon/total-bonus.png">
											</v-col>
											<v-col cols="10" sm="9" md="9">
												<div v-if="userData.member_id == '1'" class="font-size-13 white--text font-weight-600">{{ 0 | toCurrencyFormat }}</div>
												<div v-else class="font-size-13 white--text font-weight-600">{{ summaryKomisi.totalAcc | toCurrencyFormat }}</div>
												<div class="font-size-10 white--text font-weight-bold">Total Earned</div>
											</v-col>
										</v-row>
									</v-card>
								</v-col>

								<v-col cols="12" sm="12" md="4" xl="4" class="pt-0 pt-sm-3 pl-0">
									<v-card class="px-2 py-4 elevation-0 rounded-xl hover-shadow teal lighten-2">
										<v-row>
											<v-col cols="2" sm="3" md="3" class="pr-0 my-auto text-right">
												<img class="img-fluid filter-white" src="/assets/icon/total-dibayarkan.png">
											</v-col>
											<v-col cols="10" sm="9" md="9">
												<div v-if="userData.member_id == '1'" class="font-size-13 white--text font-weight-600">{{ 0 | toCurrencyFormat }}</div>
												<div v-else class="font-size-13 white--text font-weight-600">{{ summaryKomisi.totalPaid | toCurrencyFormat }}</div>
												<div class="font-size-10 white--text font-weight-bold">Total Paid</div>
											</v-col>
										</v-row>
									</v-card>
								</v-col>

								<v-col cols="12" sm="12" md="4" xl="4" class="pt-0 pt-sm-3 pl-0">
									<v-card class="px-2 py-4 elevation-0 rounded-xl hover-shadow amber darken-2">
										<v-row>
											<v-col cols="2" sm="3" md="3" class="pr-0 my-auto text-right">
												<img class="img-fluid filter-white" src="/assets/icon/saldo.png">
											</v-col>
											<v-col cols="10" sm="9" md="9">
												<div v-if="userData.member_id == '1'" class="font-size-13 white--text font-weight-600">{{ 0 | toCurrencyFormat }}</div>
												<div v-else class="font-size-13 white--text font-weight-600">{{ summaryKomisi.totalSaldo | toCurrencyFormat }}</div>
												<div class="font-size-10 white--text font-weight-bold">Total Balance</div>
											</v-col>
										</v-row>
									</v-card>
								</v-col>
							</v-row>

							<template v-if="summaryKomisi.arrBonus">
								<div v-for="(komisi, idb) in summaryKomisi.arrBonus" :key="idb">
									<v-card class="px-4 py-3 elevation-0 rounded-xl hover-shadow" :class="{'mt-3': (idb > 0)}">
										<v-row>
											<v-col cols="12" sm="12" md="4" class="my-auto flex-column">
												<div class="d-flex">
													<div>
														<div class="font-size-9 cl-grey">Bonus</div>
														<div class="font-size-12 cl-primary font-weight-500">{{komisi.label}}</div>
													</div>
													<div class="mt-auto" v-if="komisi.label == 'Unilevel' && userData.member_id !== '1'">
														<v-btn small depressed color="primary" class="ml-3 white--text rounded-xl text-capitalize" @click="gotoKomisiTeam">Details</v-btn>
													</div>
												</div>
											</v-col>

											<template v-if="userData.member_id == '1'">
												<v-col cols="12" sm="12" md="8" class="pt-0 pt-sm-3 my-auto d-none d-md-flex">
													<v-row>
														<v-col cols="12" sm="12" md="4" class="pt-0 pt-sm-3 my-auto ">
															<div class="font-size-10 cl-grey">Earned</div>
															<div class="font-size-12 cyan--text text--darken-1 font-weight-500">{{ 0 | toCurrencyFormat }}</div>
														</v-col>
														<v-col cols="12" sm="12" md="4" class="pt-0 pt-sm-3 my-auto">
															<div class="font-size-10 cl-grey">Paid</div>
															<div class="font-size-12 teal--text text-lighten-2 font-weight-500">{{ 0 | toCurrencyFormat }}</div>
														</v-col>
														<v-col cols="12" sm="12" md="4" class="pt-0 pt-sm-3 my-auto text-right">
															<div class="font-size-10 cl-grey">Balance</div>
															<div class="font-size-12 cl-primary font-weight-500">{{ 0 | toCurrencyFormat }}</div>
														</v-col>
													</v-row>
												</v-col>

												<v-col cols="12" sm="12" md="8" class="pt-0 pt-sm-3 my-auto d-flex d-md-none">
													<v-row>
														<v-col cols="12" sm="12" md="4" class="pt-sm-0 pb-1 my-auto d-flex align-center justify-space-between">
															<div class="font-size-10 cl-grey">Earned</div>
															<div class="font-size-10 yellow--text text--darken-3 font-weight-500">{{ 0 | toCurrencyFormat }}</div>
														</v-col>
														<v-col cols="12" sm="12" md="4" class="pt-0 pb-1 my-auto d-flex align-center justify-space-between" >
															<div class="font-size-10 cl-grey">Paid</div>
															<div class="font-size-10 green--text font-weight-500">{{ 0 | toCurrencyFormat }}</div>
														</v-col>
														<v-col cols="12" sm="12" md="4" class="pt-0 pb-4 my-auto d-flex align-center justify-space-between" >
															<div class="font-size-10 cl-grey">Balance</div>
															<div class="font-size-10 blue--text font-weight-500">{{ 0 | toCurrencyFormat }}</div>
														</v-col>
													</v-row>
												</v-col>
											</template>

											<template v-else>
												<v-col cols="12" sm="12" md="8" class="pt-0 pt-sm-3 my-auto d-none d-md-flex">
													<v-row>
														<v-col cols="12" sm="12" md="4" class="pt-0 pt-sm-3 my-auto ">
															<div class="font-size-10 cl-grey">Earned</div>
															<div class="font-size-12 cyan--text text--darken-1 font-weight-500">{{ komisi.acc | toCurrencyFormat }}</div>
														</v-col>
														<v-col cols="12" sm="12" md="4" class="pt-0 pt-sm-3 my-auto">
															<div class="font-size-10 cl-grey">Paid</div>
															<div class="font-size-12 teal--text text-lighten-2 font-weight-500">{{ komisi.paid | toCurrencyFormat }}</div>
														</v-col>
														<v-col cols="12" sm="12" md="4" class="pt-0 pt-sm-3 my-auto text-right">
															<div class="font-size-10 cl-grey">Balance</div>
															<div class="font-size-12 cl-primary font-weight-500">{{ komisi.saldo | toCurrencyFormat }}</div>
														</v-col>
													</v-row>
												</v-col>

												<v-col cols="12" sm="12" md="8" class="pt-0 pt-sm-3 my-auto d-flex d-md-none">
													<v-row>
														<v-col cols="12" sm="12" md="4" class="pt-sm-0 pb-1 my-auto d-flex align-center justify-space-between">
															<div class="font-size-10 cl-grey">Earned</div>
															<div class="font-size-10 yellow--text text--darken-3 font-weight-500">{{ komisi.acc | toCurrencyFormat }}</div>
														</v-col>
														<v-col cols="12" sm="12" md="4" class="pt-0 pb-1 my-auto d-flex align-center justify-space-between" >
															<div class="font-size-10 cl-grey">Paid</div>
															<div class="font-size-10 green--text font-weight-500">{{ komisi.paid | toCurrencyFormat }}</div>
														</v-col>
														<v-col cols="12" sm="12" md="4" class="pt-0 pb-4 my-auto d-flex align-center justify-space-between" >
															<div class="font-size-10 cl-grey">Balance</div>
															<div class="font-size-10 blue--text font-weight-500">{{ komisi.saldo | toCurrencyFormat }}</div>
														</v-col>
													</v-row>
												</v-col>
											</template>
										</v-row>
									</v-card>
								</div>
							</template>
						</v-col>
					</div>
				</template>
			</v-scroll-x-reverse-transition>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			loading: true,
			isActiveMember: false,
			networkType: null,
			userData: null,
			kemitraan: [
			{
				type: 'pramitra',
				color: '#03bb5a',
				belanja: '0',
				badges: '',
				classText: 'mitra-pra'
			},
			{
				type: 'silver',
				color: '#688389',
				belanja: '1.300.000',
				badges: 'assets/icon/silver.svg',
				classText: 'mitra-silver'
			},
			{
				type: 'gold',
				color: '#6e490f',
				belanja: '3.900.000',
				badges: 'assets/icon/gold.svg',
				classText: 'mitra-gold'
			},
			{
				type: 'diamond',
				color: '#2a4fd6',
				belanja: '13.000.000',
				badges: 'assets/icon/diamond.svg',
				classText: 'mitra-diamond'
			}
			],
		}
	},
	computed: {
		...mapState('komisi', ['summaryKomisi']),
		...mapState('profil', ['myProfile']),
	},
	methods: {
		...mapActions('komisi', ['getSummaryKomisi']),
		...mapActions('profil', ['getProfileMitra']),

		gotoKomisiTeam() {
			this.$router.push({name: 'detail-bonus-unilevel'})
		},
		formatKomisiLabel(text) {
			if (text) {
				if (text === 'Unilevel') return 'Team'
				else return text.replace('Komisi', '')
			} else {
				return '-'
			}
		},
		async getData() {
			this.loading = await true
			const authData = await localStorage.getItem('mlmcore-vo-auth-data');
			this.userData = await JSON.parse(authData)
			await this.getSummaryKomisi()
			await this.getProfileMitra()
			this.loading = false
		},
	},
	async created(){
		this.$store.dispatch('setPageTitle', `Bonus Summary`)
		this.getData()
	}
};
</script>

